<script setup lang="ts">
import { useRouteQuery } from '@vueuse/router/index'

const props = defineProps<{
  categoryId?: number
}>()

const itemsPerPage = ref(24)
const page = useRouteQuery('page', 1, { transform: Number })
const productLineRepository = createProductLineRepository()

const { data: productLines, status } = await useLazyAsyncData(
  () =>
    productLineRepository.getAllPagination(
      page.value,
      itemsPerPage.value,
      props.categoryId
    ),
  {
    watch: [page],
    default: defaultPaginationObject,
  }
)

const linesElement = ref<HTMLElement | null>()
watch(page, () => {
  linesElement.value?.scrollIntoView({ behavior: 'smooth' })
})
</script>

<template>
  <div v-if="status === 'pending'">
    <UiSkeletonProductCard />
  </div>
  <div>
    <div ref="linesElement" class="overflow-hidden">
      <div
        class="-mb-1 -mr-1 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4"
      >
        <ProductLinesProductLineCard
          v-for="line in productLines.items ?? []"
          :key="line.nid"
          :product-line="line"
          class="border-b-4 border-r-4 border-white"
          dark
        />
      </div>
    </div>
    <div class="flex justify-end pr-10 pt-5">
      <UiPagination
        v-model:value="page"
        :items-per-page="itemsPerPage"
        :item-count="productLines.itemCount"
        :loading="status === 'pending'"
      />
    </div>
  </div>
</template>

<style scoped></style>
